import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Field } from '@klarna/bubble-ui';
import { TOOLTIP_MODES } from 'moet-core';
import { generateCyElemId, isRunningContextCypress } from 'moet-test-utils/cypress/utils';

import { validators } from '@/flow/validation';
import AutoSuggest from '@/components/AutoSuggest';
import { CY_ADDRESS_FORM_COMPONENT_IDS, tPrefix } from '../constants';

const { INPUT_STREET } = CY_ADDRESS_FORM_COMPONENT_IDS;

export const StreetField = forwardRef((props, ref) => {
  const { showSuggestions, inputRef, ...rest } = props;
  const Component = showSuggestions ? AutoSuggest : Field;
  return (
    <div ref={ref}>
      <Component {...rest} />
    </div>
  );
});

StreetField.displayName = 'StreetField';

StreetField.propTypes = {
  showSuggestions: PropTypes.bool,
  ...AutoSuggest.propTypes,
};

export const streetField = (
  t,
  defaultField = {},
  searchCallback,
  onFocusCallback,
  showTooltip,
) => ({
  ...defaultField,
  component: StreetField,
  size: 1,
  type: 'text',
  label: defaultField.label || t(`${tPrefix}.street.label`),
  validators: [
    {
      callback: validators.common.isRequired,
      errorMessage: t(`${tPrefix}.street.error`),
    },
  ],
  extraProps: {
    ...defaultField.extraProps,
    borderless: true,
    noEmptyOption: true,
    noMatchTitle: t(`${tPrefix}.street.no_suggestion_found`, { input: '|SEARCH|' }),
    onFocus: onFocusCallback,
    onSearch: searchCallback,
    searchDebounce: 500,
    clearSelectionOnStartTyping: false,
    showSuggestions: !isRunningContextCypress(window),
    tooltipText: showTooltip ? t(`${tPrefix}.street.tooltip`) : undefined,
    tooltipMode: TOOLTIP_MODES.HELPER,
    ...generateCyElemId(INPUT_STREET, window),
    isUnderlined: true,
  },
});
